var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('page-content',[_c('common-table',{ref:"table",attrs:{"path":"web/iot/device/control-log","search-placeholder":"搜索消息内容","columns":_vm.columns,"queryParams":_vm.queryParams,"date-range":true}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }